import http from '@/utils/http';

export default {
  async getById(id) {
    return await http.get(`/api/configuracao/get/${id}`);
  },
  async insert(data) {
    return await http.post('/api/configuracao/insert', data);
  },
  async update(data) {
    return await http.post('/api/configuracao/update', data);
  },
  async delete(data) {
    return await http.post('/api/configuracao/delete', data);
  }
};